import { PushOptInBanner } from './PushOptInBanner'

/**
 * `customer-notifications` — asking to be allowed to notify, and nothing else.
 *
 * No routes: the banner renders app-wide, above the router, exactly where legacy's `App.tsx` mounts it.
 * AGOS's first draft rendered it inside the home page, so a customer who landed on `/checkout` or
 * `/moj-profil` was never asked — FB-C13.
 *
 * Whether asking is possible at all is `@agos/customer-core`'s `pushState`: the VAPID key is checked
 * before the browser is (FB-C03), because a subscription without a server key is one the server can
 * never use.
 */
export const customerNotificationsModule = {
  name: 'customer-notifications',
  banners: [{ name: 'push-opt-in', component: PushOptInBanner }],
} as const

export { PushOptInBanner } from './PushOptInBanner'
export { publicKeyOf } from './push-key'
